 import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { catchError, Observable, switchMap, throwError } from 'rxjs';
import { FormDataService } from '../Form Data/form-data.service';
import { AuthService } from '../../Auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class FormUpdateService {

    formData: any;

    headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    private baseUrl = environment.apiBaseUrl;
    private companyRoute = '/company';
    private busTypes = '/companyBusinessType';
    private contracts = '/companyContract';
    private contractDetails = '/companyContractDetails';
    private directors = '/companydirector';
    private docsRoute = '/companydocument';
    private hseRoute = '/companyHSE';
    private signatories = '/companysignatory';
    private subcontracts = '/companysubcontract';
    private subsidaries = '/companysubsidary';
    private user = '/user'

    constructor(private http: HttpClient, private formDataService: FormDataService, private authService: AuthService) {
        // this.formData = formDataService.getFormData();
    }

    //COMPANY
    updateCompany(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        return this.authService.handleTokenExpiration().pipe(
            switchMap((accessToken: string) => {
                const headers = new HttpHeaders({
                    'Authorization': `Bearer ${accessToken}`,
                });

                return this.http.patch(
                    `${this.baseUrl + this.companyRoute}/update/${companyId}`,
                    formData.company,
                    { headers, responseType: 'text' as 'json' },
                );
            }),
            catchError((error) => {
                console.error('updateCompany error:', error);
                return throwError(() => error);
            })
        );
    }

    //BUSINESS TYPE--- shouldn't be editable. no limit to how many; it's either post or delete
    // updateBusinessTypes(companyId: any): Observable<any> {
    //     const payload = {
    //         companyId: companyId,
    //         companyBusTypes: formData.companyBusTypes
    //     };
    //     return this.authService.handleTokenExpiration().pipe(
    //         switchMap((accessToken: string) => {
    //             const headers = new HttpHeaders({
    //                 'Authorization': `Bearer ${accessToken}`
    //             });
    //             return this.http.patch(`${this.baseUrl + this.busTypes}/update/${companyId}`, payload, { headers, responseType: 'text' as const });
    //         }),
    //         catchError((error) => {
    //             console.error('updateBusinessTypes error:', error);
    //             return throwError(() => error);
    //         })
    //     );
    // }

    //COMPANY CONTRACTS aka Top Customers
    updateCompanyContracts(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const payload = formData.topcustomers.map((c: { strPastCustomer: any; dteYear: any; strContractValue: any; strContactPerson: any; strContactNumber: any; strContactEmail: any; }) => ({
            strPastCustomer: c.strPastCustomer,
            dteYear: c.dteYear,
            strContractValue: c.strContractValue,
            strContactPerson: c.strContactPerson,
            strContactNumber: c.strContactNumber,
            strContactEmail: c.strContactEmail
        }));

        console.log("Outgoing payload", payload);

        return this.authService.handleTokenExpiration().pipe(
            switchMap((accessToken: string) => {
                const headers = new HttpHeaders({
                    'Authorization': `Bearer ${accessToken}`
                });
                return this.http.patch(`${this.baseUrl + this.contracts}/update/${companyId}`, payload, { headers, responseType: 'text' as const });
            }),
            catchError((error) => {
                console.error('Contracts Update error:', error);
                return throwError(() => error);
            })
        );
    }

    //CONTRACT DETAILS
    updateContractDetails(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();

        const payload = {
            companyId: companyId,
            blnAllowsSubcontracts: formData.blnAllowsSubcontracts,
            blnContractStatus: formData.blnContractStatus,
            strContractDetails: formData.strContractDetails
        };
        return this.authService.handleTokenExpiration().pipe(
            switchMap((accessToken: string) => {
                const headers = new HttpHeaders({
                    'Authorization': `Bearer ${accessToken}`
                });
                return this.http.patch(`${this.baseUrl + this.contractDetails}/update/${companyId}`, payload, { headers, responseType: 'text' as const });
            }),
            catchError((error) => {
                console.error('Contract details update error:', error);
                return throwError(() => error);
            })
        );
    }

    //COMPANY DIRECTOR
    // --- not a set count of records so it shouldn't be editable. no limit to how many; it's either post or delete
    // updateDirector(companyId: any): Observable<any> {
    //     const formData = this.formDataService.getFormData();

    //     const payload = {
    //         companyId: companyId,
    //         data: formData.directors
    //     };
    //     return this.authService.handleTokenExpiration().pipe(
    //         switchMap((accessToken: string) => {
    //             const headers = new HttpHeaders({
    //                 'Authorization': `Bearer ${accessToken}`
    //             });
    //             return this.http.patch(`${this.baseUrl + this.directors}/update/${companyId}`, payload, { headers, responseType: 'text' as const });
    //         }),
    //         catchError((error) => {
    //             console.error('Director update error:', error);
    //             return throwError(() => error);
    //         })
    //     );
    // }

    //DOCUMENTS
    updateDocuments(companyId: number): Observable<any> {
        const formData = this.formDataService.getFormData();

        console.log("Documents in update: ", formData.documents);

        const companyDocument = {
            hasVatDocument: formData.documents.hasVatDocument,
            vatRegistrationNo: formData.documents.vatRegistrationNo || '',
            noVatReason: formData.documents.noVatReason || '',
            vatExpiryDate: formData.documents.vatExpiryDate || '',

            hasBirDocument: formData.documents.hasBirDocument,
            birNo: formData.documents.birNo || '',
            noBirReason: formData.documents.noBirReason || '',

            hasNibDocument: formData.documents.hasNibDocument,
            nibNo: formData.documents.nibNo || '',
            noNibReason: formData.documents.noNibReason || '',
            nibExpiryDate: formData.documents.nibExpiryDate || '',

            hasIncorporationCertificate: formData.documents.hasIncorporationCertificate,
            noIncorporationReason: formData.documents.noIncorporationReason || '',

            hasRegistrationCertificate: formData.documents.hasRegistrationCertificate,
            hasCompanyProfile: formData.documents.hasCompanyProfile,

            hasGeneralLicenses: formData.documents.hasGeneralLicenses,
            generalLicensesExpiryDate: formData.documents.generalLicensesExpiryDate || ''
        };

        const docFormData = new FormData();
        docFormData.append('companyDocument', new Blob([JSON.stringify(companyDocument)], { type: 'application/json' }));

        if (formData.documents.vatFile) docFormData.append('vatFile', formData.documents.vatFile);
        if (formData.documents.birFile) docFormData.append('birFile', formData.documents.birFile);
        if (formData.documents.nibFile) docFormData.append('nibFile', formData.documents.nibFile);
        if (formData.documents.incorpFile) docFormData.append('incorporationFile', formData.documents.incorpFile);
        if (formData.documents.regFile) docFormData.append('registrationFile', formData.documents.regFile);
        if (formData.documents.companyFile) docFormData.append('companyProfileFile', formData.documents.companyFile);
        if (formData.documents.licenseFile) docFormData.append('licenseFile', formData.documents.licenseFile);
        if (formData.documents.tcFile) docFormData.append('tcFile', formData.documents.tcFile);
        if (formData.documents.conductFile) docFormData.append('conductFile', formData.documents.conductFile);


        return this.authService.handleTokenExpiration().pipe(
            switchMap((accessToken: string) => {
            const headers = new HttpHeaders({
                'Authorization': `Bearer ${accessToken}`
            });
            return this.http.patch(
                `${this.baseUrl + this.docsRoute}/update/${companyId}`,
                docFormData,
                { headers, responseType: 'text' as const }
            );
            }),
            catchError((error) => {
            console.error('docs update error:', error);
            return throwError(() => error);
            })
        );
    }


    //HSE
    updateHSE(companyId: any): Observable<any> {

         const formData = this.formDataService.getFormData();
        const hse = formData.hse_docs ?? {};

        console.log("HSE in update: ", formData.hse_docs);

        const hseDocument = {
            hasSafetyFile: hse.hasSafetyFile,
            hasTrainingFile: hse.hasTrainingFile,
            hasResourcesFile: hse.hasResourcesFile,
            agreedToSustainabilityChecklist: hse.agreedToSustainabilityChecklist === true,
        };

        const hseFormData = new FormData();
        hseFormData.append('hseDocument', new Blob([JSON.stringify(hseDocument)], { type: 'application/json' }));

        if (hse.safetyFile) hseFormData.append('safetyFile', hse.safetyFile);
        if (hse.trainingFile) hseFormData.append('trainingFile', hse.trainingFile);
        if (hse.resourcesFile) hseFormData.append('resourcesFile', hse.resourcesFile);

        return this.authService.handleTokenExpiration().pipe(
            switchMap((accessToken: string) => {
            const headers = new HttpHeaders({
                'Authorization': `Bearer ${accessToken}`
            });
            return this.http.patch(
                `${this.baseUrl  + this.hseRoute}/update/${companyId}`,
                hseFormData,
                { headers, responseType: 'text' as const }
            );
            }),
            catchError((error) => {
            console.error('hse update error:', error);
            return throwError(() => error);
            })
        );

    }

    //SIGNATORIES 
    // --- not a set count of records so it shouldn't be editable. no limit to how many; it's either post or delete
    // updateSignatories(companyId: any): Observable<any> {
    //     const formData = this.formDataService.getFormData();

    //     const payload = {
    //         companyId: companyId,
    //         data: formData.authsignatories
    //     };
    //     return this.authService.handleTokenExpiration().pipe(
    //         switchMap((accessToken: string) => {
    //             const headers = new HttpHeaders({
    //                 'Authorization': `Bearer ${accessToken}`
    //             });
    //             return this.http.patch(`${this.baseUrl + this.signatories}/update/${companyId}`, payload, { headers, responseType: 'text' as const });
    //         }),
    //         catchError((error) => {
    //             console.error('signatories update error:', error);
    //             return throwError(() => error);
    //         })
    //     );
    // }

    //SUBCONTRACTS
    // --- not a set count of records so it shouldn't be editable. no limit to how many; it's either post or delete
    // updateSubcontracts(companyId: any): Observable<any> {
    //     const formData = this.formDataService.getFormData();

    //     const payload = {
    //         companyId: companyId,
    //         data: Array.isArray(formData.strPrimaryWorkSubContracted)
    //             ? formData.strPrimaryWorkSubContracted.map((item: any) =>
    //                 typeof item === "string" ? { strPrimaryWorkSubContracted: item } : item)
    //             : [{ strPrimaryWorkSubContracted: formData.strPrimaryWorkSubContracted }]
    //     };
    //     return this.authService.handleTokenExpiration().pipe(
    //         switchMap((accessToken: string) => {
    //             const headers = new HttpHeaders({
    //                 'Authorization': `Bearer ${accessToken}`
    //             });
    //             return this.http.patch(`${this.baseUrl + this.subcontracts}/update/${companyId}`, payload, { headers, responseType: 'text' as const });
    //         }),
    //         catchError((error) => {
    //             console.error('subcontracts update error:', error);
    //             return throwError(() => error);
    //         })
    //     );
    // }

    //SUBSIDARIES
    // --- not a set count of records so it shouldn't be editable. no limit to how many; it's either post or delete
    // updateSubsidaries(companyId: any): Observable<any> {
    //     const formData = this.formDataService.getFormData();

    //     const payload = {
    //         companyId: companyId,
    //         data: formData.subsidaries
    //     };
    //     return this.authService.handleTokenExpiration().pipe(
    //         switchMap((accessToken: string) => {
    //             const headers = new HttpHeaders({
    //                 'Authorization': `Bearer ${accessToken}`
    //             });
    //             return this.http.patch(`${this.baseUrl + this.subsidaries}/update/${companyId}`, payload, { headers, responseType: 'text' as const });
    //         }),
    //         catchError((error) => {
    //             console.error('subsidaries update error:', error);
    //             return throwError(() => error);
    //         })
    //     );
    // }

    //USER 
    updateUser(companyId: any): Observable<any> {
        const formData = this.formDataService.getFormData();
        const userData = new FormData();

        const { signatureFile, ...rest } = formData.user;

        // List of fields to exclude from backend payload
        const fieldsToOmit = ['enabled', 'id', 'createdAt', 'authorities', 'username', 'accountNonExpired', 'accountNonLocked', 'credentialsNonExpired', 'usingTemporaryPassword'];
        const plainObject = Object.fromEntries(
            Object.entries(rest).map(([key, descriptorOrValue]) => {
                if (descriptorOrValue && typeof descriptorOrValue === 'object' && 'value' in descriptorOrValue) {
                return [key, descriptorOrValue.value];
                }
                return [key, descriptorOrValue];
            })
        )

        const userWithoutFile = Object.fromEntries(
            Object.entries(plainObject).filter(([key]) => !fieldsToOmit.includes(key))
        );

        userData.append('user', JSON.stringify(userWithoutFile));
        
        console.log("[updateUser]: ", userWithoutFile);
        console.log('JSON payload:', JSON.stringify(userWithoutFile));

        if (signatureFile) {
            userData.append('signatureFile', signatureFile);
        }

        const vendorConsent = formData.vendorConsent;
        if (vendorConsent?.accepted === true) {
            userData.append(
                'vendorConsent',
                new Blob([JSON.stringify({
                    consentVersion: vendorConsent.version,
                    consentText: vendorConsent.consentText,
                })], { type: 'application/json' })
            );
        }

        return this.authService.handleTokenExpiration().pipe(
            switchMap((accessToken: string) => {
                const headers = new HttpHeaders({
                    'Authorization': `Bearer ${accessToken}`
                });
                return this.http.post(`${this.baseUrl + this.user}/update/${companyId}`, userData, { headers, responseType: 'text' as const });
            }),
            catchError((error) => {
                console.error('user update error:', error);
                return throwError(() => error);
            })
        );
    }

}
